// extracted by mini-css-extract-plugin
export default {"styles":"styles___N6C3T"};